import TextArea from "antd/es/input/TextArea";
import PropTypes from "prop-types";
import FormItem from "antd/es/form/FormItem";
import { Form } from "antd";

StudyFeedbackModal.propTypes = {
  feedbackData: PropTypes.array,
};

function StudyFeedbackModal({ feedbackData }) {
  return (
    <>
      <div
        style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "10px" }}
      >
        {feedbackData?.map((element) => {
          return (
            <div className="mb-1" key={element?.id}>
              <div className="add_descriptions">
                <b className="mx-1">
                  QC <b>{element?.feedbackQualityChecker?.name}</b> gave Revise
                  Reason to
                </b>
                <span className="mx-1">-</span>
                <b style={{ fontSize: "16px" }}>
                  Dr. {element?.feedbackRadiologist?.name}
                </b>
              </div>
              <div className="d-flex edit_descrption_textarea">
                <div style={{ width: "500px" }}>
                  <Form>
                    <FormItem>
                      <TextArea
                        autoSize={{ minRows: 2, maxRows: 8 }}
                        value={element?.feedbackText}
                      />
                    </FormItem>
                  </Form>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default StudyFeedbackModal;
